import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Garagecleanoutsheader from '../components/Servicelist3/Garagecleanoutsheader'
import Garagecleanouts from '../components/Servicelist3/Garagecleanouts'

const Garagecleanoutpages = () => {
    return (
        <div>
        <Navbar/>
        <Garagecleanoutsheader/>
        <Garagecleanouts/>


        <Footer/>
            
       </div>
    )
}

export default Garagecleanoutpages